<template>
  <div class="money">
    <Header class="get-header" titles="我的奖金">
      <router-link class="header-collection" slot="right" to="/personal">收款设置</router-link>
    </Header>
    <div class="top">
      <div class="balance">
        <!-- <div class="bonus">我的奖金</div> -->
        <div class="money-my">
          <img src="@/assets/image/money-balance.png" alt="">
          <span>
            ￥{{user.award_count | numChange}}
          </span>
        </div>
        <Popup class="v-show" v-model="show">
          <div>实际总奖金 = 任务奖金 - 个税 - 增值税</div>
          <div>增值税  = 任务奖金 * 3%</div>
          <div>（需要自行前往税务局开具劳务费的增值税发票）</div>
        </Popup>
        <!-- <div class="rule" @click="show = true"> <div class="ball">？</div> 奖金规则</div> -->
        <div class="rule">
          奖励规则 ：实际奖金 = 任务奖金 - 个税 - 增值税
          <router-link class="guide" to="/invoice">开票指引</router-link>
        </div>
      </div>
      <!-- <router-link to="/invoice" class="eve-list">
        <img src="@/assets/image/opens.png" class="right-cli" alt="">
      </router-link> -->
      <!-- <div class="oldname">历史账单</div> -->
    </div>
    <div class="list-back">
      <List
        class="vlist"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        offset="20">
        <div class="mons" v-for="item in list" :key="item.id">
          <div class="mons-title">
            <img src="@/assets/image/Money.png" alt="">
            <div>
              <div class="mons-title__name">{{item.title}}</div>
              <div class="mons-title__time">{{item.create_time}}</div>
            </div>
          </div>
          <div class="mons-mon">￥{{item.award | numChange}}</div>
        </div>
      </List>
    </div>
  </div>
</template>

<script>
import { getUserInfo, getMoneyh } from '@/api/api/user'
import { Popup, List } from 'vant'
import Header from '@/components/header'
export default {
  data() {
    return {
      user: {},
      show: false,
      finished: false,
      list: [],
      total: 0,
      isloading: true
    }
  },
  components: {
    Header,
    Popup,
    List
  },
  created() {
    this.getUser()
    this.getMoneyHis()
  },
  methods: {
    getUser() {
      getUserInfo().then(res => {
        this.user = res.data.data
      })
    },
    getMoneyHis() {
      getMoneyh(this.page).then(res => {
        console.log(res.data.data.list)
        if(res.data.errorCode == '0') {
          if(res.data.data.list.length < 10) {
            this.finished = true
          }
          this.list = [...this.list, ...res.data.data.list]
        }
      })
    },
    onLoad() {
      console.log(111)
      if(!this.isloading) return
      if((this.page *10) < this.total) {
        this.isloading = false
        this.getMoneyHis()
      }
    },
  }
}
</script>

<style lang="scss">
.money {
  height: 100%;
  padding-top: 44px;
  background: linear-gradient(159deg, #0286FF 0%, #074FC7 100%);
  overflow: hidden;
  .balance {
    color: white;
    width: 100%;
    height: 125px;
    background: url('~@/assets/image/balance-back.png');
    background-size:100% 125px;
    background-repeat:no-repeat;
    // display: flex;
    // align-items: center;
    // justify-content: center;
  }
  .top {
    .oldname {
      padding-left: 16px;
      padding-top: 14px;
      font-weight: 700;
    }
  }
  .list-back {
    padding: 0 12px;
    height: 100%;
    background: linear-gradient(159deg, #0286FF 0%, #074FC7 100%);
  }
  .vlist {
    background-color: white;
    min-height: 70vh;
    overflow-y: scroll;
    padding-left: 16px;
    border-radius: 40px;
    .mons {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f1f1f1;
      margin-bottom: 26px;
      .mons-title {
        display: flex;
        align-items: center;
        .mons-title__name {
          font-weight: 700;
          font-size: 14px;
          padding-bottom: 6px;
        }
        .mons-title__time {
          font-size: 12px;
          color: #858585;
        }
        img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
        }
      }
      .mons-mon {
        line-height: 60px;
        height: 100%;
        width: 94px;
        text-align: center;
        border-left: 1px solid #f1f1f1;
      }
    }
  }
  .money-get {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    .money-cl {
      width: 60%;
      background-color: #BE0000;
      color: white;
      text-align: center;
      height: 46px;
      line-height: 46px;

    }
  }
  .eve-list {
      .right-cli {
        width: 100%;
      }
    }
  .rule {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    margin-left: -10px;
    font-size: 12px;
    .ball {
      border: 1px solid black;
      border-radius: 50%;
      margin-right: 3px;
      font-size: 12px;
      line-height: 12px;
    }
    .guide {
      color: white;
      padding: 0 14px;
      height: 22px;
      border-radius: 4px;
      margin-left: 10px;
      line-height: 22px;
      opacity: 0.9;
      border: 1px dashed white;
      background-color: #B4DBFF;
    }
  }
  .header-collection {
      display: inline-block;
      color: white;
      font-size: 12px;
      padding: 0 14px;
      height: 22px;
      border-radius: 4px;
      margin-left: 10px;
      line-height: 22px;
      opacity: 0.9;
      background-color: #0286FF;
  }
  .v-show {
    padding: 30px 0;
    border-radius: 10px;
    width: 80%;
    text-align: center;
  }
  .bonus {
    height: 30px;
    line-height: 70px;
    font-size: 14px;
    text-align: center;
    color: #999;
  }
  .money-my {
    font-size: 30px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 20%;
    padding-top: 20px;
    img {
      width: 120px;
      height: 55px;
      margin-right: 10%;
    }
  }
  .get-header {
    position: fixed;
    top: 0;
    width: 100%;
    .rislot {
      color: black;
    }
  }
}
</style>